/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'system-reports';

export const reportsFailedLabel = `${prefix}.reportsFailedLabel`;
export const reportsInprogressLabel = `${prefix}.reportsInprogressLabel`;
export const reportsStartedLabel = `${prefix}.reportsStartedLabel`;
export const reportsSuccessfulLabel = `${prefix}.reportsSuccessfulLabel`;
export const reportsWarningLabel = `${prefix}.reportsWarningLabel`;

export const ENGLISH = {
    [reportsFailedLabel]: 'Failed',
    [reportsInprogressLabel]: 'In Progress',
    [reportsStartedLabel]: 'Started',
    [reportsSuccessfulLabel]: 'Successful',
    [reportsWarningLabel]: 'Warning',
};
